/**
* @name: right-app-menu-list
* @author: weiyong
* @date: 2023-05-14 18:19
* @description：right-app-menu-list
* @update: 2023-05-14 18:19
*/
<template>
  <div :class="prefixCls" class="right-area-div w100b">
    <div @click="selActiveOneMenu(item)"
         :key="item.id"
         :class="menuProps.activeMenuKey===item.id?'active-menu':'not-active-menu'"
         type="link"
         class="w100b menu-btn" v-for="item in menusRef">
      <span class="icon-men" :class="item.source"></span>
      <span class="menu-name">
        {{ item.name || item.label }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "right-app-menu-list",
});
</script>

<script lang="ts" setup>
import {useDesign} from "@/hooks/web/useDesign";
import {useRouter} from "vue-router";
import {useMenuHooks} from "@/layouts/layoutFrame/hooks/useMenuHooks";
import {useMenuStore} from "@/layouts/layoutFrame/military/viewStore/menuStore";
import {useI18n} from "@/hooks/web/useI18n";

const {prefixCls} = useDesign('right-app-menu-list');
const router = useRouter();
const { t } = useI18n();
const {
  menusRef,
  genAppMenus
} = useMenuHooks(router,t);

const menuStore = useMenuStore();
const {
  menuProps
}:any = storeToRefs(menuStore)

/**
 * 选择的第一层菜单
 */
const selActiveOneMenu=function (item){
  unref(menuProps).activeMenuKey=item.id;
  if(item&&item.children){
    unref(menuProps).subMenus=item.children;
    unref(menuProps).mainMenu=item;
  }
}
genAppMenus(false,(menusAll)=>{
  unref(menuProps).menusAll=menusAll;
  if(menusAll&&menusAll.length>0){
    unref(menuProps).activeMenuKey=menusAll[0].id;
    selActiveOneMenu(menusAll[0]);
  }
});
</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-right-app-menu-list';

.@{prefix-cls} {
  &.right-area-div{
    position: relative;
    z-index: 200;
    left:-1px;
  }
  .menu-btn {
    text-align: left;
    border-left:2px solid #eee;
    line-height: var(--menu-main-bar-height,38px);
    padding-left: 12px;
    cursor:pointer;
    position: relative;
    color:#666;
    &:hover{
      background-color: #F0F0F0;
    }
    .icon-men{
      display: inline-block;
      padding-right: 6px;
    }

    &:hover{
      color:var(--primary-color,#0a6eff);
      border-left:2px solid var(--primary-color,#0a6eff);
      z-index: 100;
    }
    &.active-menu{
      background-color: #F0F0F0;
      color:var(--primary-color,#0a6eff);
      border-left:2px solid var(--primary-color,#0a6eff);
      &:before{
        content: ' ';
        width: 4px;
        background-color: var(--primary-color,#F15001);
        position: absolute;
        height: 100%;
        position: absolute;
        border-radius: 0 2px 2px 0;
        left: -2px;
        top: 0;
      }
    }
  }

}
</style>
